import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationHandlerService } from '../../../../lib/services/validation-handler.service';
import { TranslatedToastrService } from '../../../../lib/services/translated-toastr.service';
import {
    ListItemModel,
    StringListItemModel,
} from '../../../../lib/services/api-services';
import { CoreService_TOKEN } from '../../../../lib/tokens/injection-tokens';
import { ICoreService } from '../../../../lib/interfaces/core-service.interface';
import { CustomValidators } from '../../../../lib/customvalidators/custom-validators.class';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseComponent } from '../../../../lib/components/base-components/base-component.component';
@Component({
    selector: 'app-address-edit',
    templateUrl: './address-edit.component.html',
    styleUrls: ['./address-edit.component.scss'],
})
export class AddressEditComponent extends BaseComponent {
    @Output() formGroup = new EventEmitter<FormGroup>();

    public countryList: ListItemModel[];
    public addressForm: FormGroup = this.getFormGroup();
    public showStateSelect: boolean = false;
    public stateList: StringListItemModel[];

    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService,
        protected override  validationHandlerService: ValidationHandlerService,
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    private getFormGroup(): FormGroup {
        return new FormGroup({
            addressId: new FormControl({ value: 0, disabled: true }),
            countryId: new FormControl(0, [CustomValidators.selectRequired]),
            postalCode: new FormControl('', [Validators.required]),
            cityName: new FormControl('', [Validators.required]),
            state: new FormControl('', [CustomValidators.selectRequired]),
            address1: new FormControl('', [Validators.required]),
            address2: new FormControl(''),
            address3: new FormControl(''),
            country: new FormGroup({
                id: new FormControl({
                    value: Number,
                    disabled: false,
                }),
                key: new FormControl({
                    value: String,
                    disabled: false,
                }),
                isEnabled: new FormControl({
                    value: Boolean,
                    disabled: false,
                }),
            }),
        });
    }

    public ngOnInit() {
        this.getCountryList();
        this.getStateList();
        this.addressForm = this.getFormGroup();
        this.formGroup.emit(this.addressForm);
    }

    public onCountrySelected() {
        const usCountryId = this.countryList?.find(
            (x) => x.text == 'country.united_states'
        ).value;
        const selectedCountry = this.addressForm.get('countryId')?.value;
        this.showStateSelect = selectedCountry === usCountryId;
        if (this.showStateSelect) {
            const currentState = this.addressForm.get('state')?.value;
            if (!currentState || currentState === 0) {
                this.addressForm.get('state')?.setValue(0);
            }
        } else {
            const currentState = this.addressForm.get('state')?.value;
            if (!currentState || currentState === 0) {
                this.addressForm.get('state').setValue('');
            }
        }
    }

    private getCountryList() {
        this.handleSpinner(firstValueFrom(this.coreService.getCountryList())
            .then((res) => {
                this.countryList = res.result.sort((a, b) => {
                    if (a.text === 'country.united_states') return -1;
                    if (b.text === 'country.united_states') return 1;
                    return 0;
                });

                this.onCountrySelected();
                return Promise.resolve(res);
            })
            .catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err)
            }));
    }

    private getStateList() {
        this.handleSpinner(firstValueFrom(this.coreService.getStateList())
            .then((res) => {
                this.stateList = res.result;
                return Promise.resolve(res);
            })
            .catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err)
            }));
    }
}
